import { SkeletonBox } from '@practium/ui';
import styles from './InsertionList.module.css';

export const InsertionRowSkeleton = () => (
	<div className={styles.row}>
		<SkeletonBox width="1.1rem" height="1.1rem" borderRadius="50%" />
		<div className={styles.rowContent}>
			<SkeletonBox width="14rem" height="1rem" />
			<SkeletonBox width="9rem" height="0.8rem" />
		</div>
	</div>
);
